"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshUserInstallations = void 0;
const axios_1 = __importDefault(require("axios"));
const __1 = require("..");
async function refreshUserInstallations(options, headers) {
    const { 
    // includeInstallationRepositories,
    includeInstallationToken, } = options;
    const response = await axios_1.default.post(__1.constants.GRAPHQL_ENDPOINT, {
        query: `
        mutation {
          refreshUserInstallations {
            id
            account {
              id
              nodeId
              login
              avatarUrl
              htmlUrl
            }
            ${''
        /*
        includeInstallationRepositories
          ? `
            repositories {
              id
              nodeId
              ownerName
              repoName
              private
              permissions
              htmlUrl
            }
            `
          : ''
          */
        }
            ${includeInstallationToken
            ? `
                  tokenDetails {
                    token
                    expiresAt
                  }
                `
            : ''}
            htmlUrl
          }
        }
      `,
    }, { headers });
    const { data, errors } = response.data;
    if ((errors && errors.length) || !(data && data.refreshUserInstallations)) {
        throw Object.assign(new Error('GraphQL Error'), { response });
    }
    return data.refreshUserInstallations;
}
exports.refreshUserInstallations = refreshUserInstallations;
//# sourceMappingURL=installations.js.map